function cleanPlatoNameValue(value) {
  if (value === null || value === undefined) return "";

  if (Array.isArray(value)) {
    for (const item of value) {
      const cleaned = cleanPlatoNameValue(item);
      if (cleaned) return cleaned;
    }
    return "";
  }

  if (typeof value === "object") {
    for (const key of ["value", "label", "name", "text"]) {
      const cleaned = cleanPlatoNameValue(value[key]);
      if (cleaned) return cleaned;
    }
    return "";
  }

  const normalized = String(value).replace(/\u00a0/g, " ").trim().replace(/\s+/g, " ");
  if (!normalized) return "";
  if (["not available", "none", "null", "n/a", "na", "-"].includes(normalized.toLowerCase())) {
    return "";
  }
  return normalized;
}

export function extractPlatoPreferredName(directoryRow, customFieldCode) {
  const code = cleanPlatoNameValue(customFieldCode);
  const custom = directoryRow?.raw?.custom;
  if (!code || !custom || typeof custom !== "object") return "";
  return cleanPlatoNameValue(custom[code]);
}

export function resolveTemplatePatientName({ appointmentName, directoryRow, customFieldCode }) {
  const preferredName = extractPlatoPreferredName(directoryRow, customFieldCode);
  if (preferredName) return preferredName;
  return cleanPlatoNameValue(directoryRow?.name) || cleanPlatoNameValue(appointmentName);
}

export function mapAppointmentsWithPlatoTemplateNames(
  appointments,
  directoryRows,
  customFieldCode,
) {
  const usesPreferredName = Boolean(cleanPlatoNameValue(customFieldCode));
  const directoryByPatientId = new Map(
    (directoryRows || [])
      .filter((row) => row?.patient_id)
      .map((row) => [String(row.patient_id), row]),
  );

  return (appointments || []).map((appointment) => {
    const directoryRow = directoryByPatientId.get(String(appointment?.patient_id || ""));
    const patientName = resolveTemplatePatientName({
      appointmentName: appointment?.patient_name,
      directoryRow,
      customFieldCode,
    });
    const fullName = cleanPlatoNameValue(directoryRow?.name) || cleanPlatoNameValue(appointment?.patient_name);
    const preferredName = extractPlatoPreferredName(directoryRow, customFieldCode);

    return {
      ...appointment,
      patient_name: fullName || appointment?.patient_name || "",
      patient_template_name: patientName || fullName || appointment?.patient_name || "",
      patient_full_name: fullName || undefined,
      patient_preferred_name: preferredName || undefined,
      patient_uses_preferred_name: usesPreferredName && Boolean(directoryRow),
    };
  });
}
